<template>
    <v-app id="aed">
        <v-navigation-drawer expand-on-hover app clipped v-model="drawer" dark>

            <v-list v-if="permissionsLoaded">
                <v-list-item v-for="item in $store.getters.getMenuItems"  v-show="item.active === true"
                    :to="!item.href ? { name: item.route } : null" :href="item.href || null"
                    :target="item.newWindow ? '_blank' : '_self'">
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>

                            {{ t('menu', item.text) }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>

        </v-navigation-drawer>

        <v-app-bar app clipped-left light color="white">

            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="mr-12 align-center mt-2">
                <router-link to="/">
                    <img src="./assets/aedlogo.png" height="58px" class="pa-1"
                        :title="$store.getters.getCurrentBuildHash" />

                </router-link>

            </v-toolbar-title>

            <v-progress-linear :active="$store.getters.getLoadingState" :indeterminate="$store.getters.getLoadingState"
                absolute bottom color="blue darken-3"></v-progress-linear>


            <div class="flex-grow-1"></div>
            <v-btn href="/t_n_t/" text :hint='this.t("common", "STR_CLASSICINTERFACE")'>
                <v-icon>mdi-microsoft-windows-classic</v-icon>
                {{ this.t("common", "STR_CLASSICINTERFACE") }}
            </v-btn>

            <v-menu offset-y :offset="[830, 100]" v-if="permissionsLoaded">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                        <country-flag v-if="permissionsLoaded" :country='currentLanguageFlag' size='small' />
                        <span class="ml-3">{{ t("common", "STR_LANG") }}</span>
                        <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item-group>
                        <v-list-item v-for="(item, index) in $languageItems" :key="index"
                            @change="changeLanguage(item)">
                            <v-list-item-icon>
                                <country-flag :country='item.flag' size='small' v-if="item.flag" />
                            </v-list-item-icon>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>


            <v-menu offset-y :offset="[330, 100]" v-if="$store.getters.userLoggedIn">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                        <v-list-item offset-y>
                            <v-list-item-avatar color="teal white--text" size="30">
                                {{ $store.getters.getLoggedInUsername.substring(0, 1).toUpperCase() }}
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $store.getters.getLoggedInUsername }}</v-list-item-title>

                            </v-list-item-content>
                        </v-list-item>
                        <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item-group>
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>{{ $vuetify.theme.dark ? 'mdi-weather-night' : 'mdi-white-balance-sunny'
                                    }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Dark Mode</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-switch v-model="$vuetify.theme.dark" @change="toggleTheme" hide-details
                                    @click.stop></v-switch>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item to="newPassword">
                            <v-list-item-icon>
                                <v-icon>mdi-key</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ t("menu", "STR_CHPW") }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item @click.prevent="logout()">
                            <v-list-item-icon>
                                <v-icon>mdi-logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ t("menu", "STR_LOGOFF") }}</v-list-item-title>
                        </v-list-item>

                    </v-list-item-group>
                </v-list>
            </v-menu>





        </v-app-bar>

        <v-main>
           
            <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        <v-icon :color="typeColor" left class="mr-2">{{ typeIcon }}</v-icon>
                        {{ $store.getters.getMessage.type.toUpperCase() }}
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text v-html="$store.getters.getMessage.text"
                        class="text-subtitle-1 pa-4 pl-8"></v-card-text>


                    <v-divider></v-divider>

                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="close()">
                            {{ t("common", "STR_CLOSE") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <aed-update-dialog :isUpdateAvailable="isUpdateAvailable" />
            <v-container fluid>
                <router-view></router-view>
            </v-container>




        </v-main>
    </v-app>
</template>
<style>
/* @import url('https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap');  */
.v-application--wrap>.v-main {

    /* Wichtig: Nutzt den Nachbar-Selektor, um zu prüfen, ob der Drawer aktiv ist */
    /* Die Klasse .v-navigation-drawer--mini-variant wird von Vuetify bei 'expand-on-hover'
       gesetzt, wenn der Drawer NICHT ausgeklappt ist. */

    &+.v-navigation-drawer.v-navigation-drawer--mini-variant {
        /* Setzt das Padding auf die Mini-Variante Breite (typischerweise 56px) */
        /* !important ist hier oft nötig, um die Vuetify-Regel zu überschreiben */
        padding-left: 56px !important;
    }
}

@font-face {
    font-family: 'Roboto Slab';
    src: url('./assets/fonts/roboto_slab/RobotoSlab-VariableFont_wght.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
}

.gm-style-iw-d {
    color: rgba(0, 0, 0, 0.87) !important;
}


.v-application {
    font-family: 'Roboto Slab', serif !important;

}

.theme--light.v-app-bar.v-toolbar.v-sheet {
    background-color: white;
}

.v-toolbar__title {
    overflow: visible;
    min-width: 100px;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
    padding: 0 6px !important;
    font-size: smaller;
}

/* html {
    font-family: 'Roboto Slab', serif !important;

} */
</style>
<script>
import router from './router';
import store from './store';

const fetchInitialHash = async () => {
    try {
        const response = await fetch(`/version.json?t=${Date.now()}`);
        const data = await response.json();
        return data.buildHash;
    } catch (error) {
        console.error('Fehler beim Abrufen des initialen Build-Hashs, App startet möglicherweise ohne Versions-Check.', error);
        return null;
    }
};

export default {
    props: {
        source: String,
        selectedLanguage: String,
    },

    data: () => ({
        drawer: null,


    }),
    computed: {
        currentBuildHash() {
            return this.$store.state.user.currentBuildHash;
        },
        isUpdateAvailable() {
            return this.$store.state.user.isUpdateAvailable;
        },
        isDev() {
            return process.env.NODE_ENV !== 'production';
        },
        typeIcon() {
            const type = this.$store.getters.getMessage.type;
            switch (type) {
                case 'error': return 'mdi-alert-circle';
                case 'success': return 'mdi-check-circle';
                case 'warning': return 'mdi-alert';
                case 'info': return 'mdi-information';
                default: return 'mdi-bell';
            }
        },
        typeColor() {
            const type = this.$store.getters.getMessage.type;
            switch (type) {
                case 'error': return 'red darken-2';
                case 'success': return 'green darken-2';
                case 'warning': return 'orange darken-2';
                case 'info': return 'blue darken-2';
                default: return 'grey';
            }
        },

        currentLanguageFlag() {
            let languageItems = $languageItems;
            let lang = languageItems.find(item => item.code === this.$store.getters.getLanguage);
            if (lang === undefined) {
                return "de";
            } else {
                return lang.flag;
            }

        },


        permissionsLoaded() {
            return (this.$store.state.getPermissions != {});
        },
        dialog: {
            get() {
                return this.$store.state.message.display;
            },
            set(val) {
                if (val == true) {

                } else {
                    this.$store.dispatch("hideMessage");
                }

            }
        }
    },

    /**
* Checks if a language is already set.
* 
* If not, determines the preferred language based on the browser settings.  
* If the browser language is not among the available languages, defaults to German.  
* Also loads translation strings if necessary.
*/

    created() {
        this.$store.commit('setIsUpdateAvailable', false);
        this.initializeHash();
        //this.$vuetify.theme.dark = false
        const savedTheme = localStorage.getItem('userTheme');
        if (savedTheme) {
            this.$vuetify.theme.dark = savedTheme === 'dark';
        } else {
            this.$vuetify.theme.dark = false
        }

        if (!this.$store.getters.getLanguage) {
            let browserLanguage = navigator.language.substring(0, 2);
            const found = this.$languageItems.some(language => language.code === browserLanguage);
            if (found === false) {
                browserLanguage = "de";
            }

            if (!this.$store.getters.languageLoaded) {
                this.$store.dispatch("loadLanguage", { lang: browserLanguage, save: false, reload: false });
            }
        }

    },


    methods: {
        toggleTheme() {
            // HINWEIS: NICHT MEHR DIE THEME-EIGENSCHAFT INVERTIEREN (kein "!")

            // Den NEUEN Zustand abrufen (der bereits durch v-model gesetzt wurde)
            const isDark = this.$vuetify.theme.dark;

            // Nur den neuen Zustand im Local Storage speichern
            localStorage.setItem('userTheme', isDark ? 'dark' : 'light');
        },
        close() {
            this.$store.dispatch("hideMessage");
        },

        /**
         * Switches the application language if it differs from the currently active one.
         * 
         * Loads new translation strings and updates the app state accordingly.
         * 
         * @param item - selected Language
         */
        changeLanguage(item) {

            if (this.$store.getters.getLanguage === item.code) {
                return;
            }
            console.log(this.$store.getters.userLoggedIn)
            if (this.$store.getters.userLoggedIn) {

                this.$store.dispatch('loadLanguage', { lang: item.code, save: true, reload: true });
            } else {
                this.$store.dispatch("loadLanguage", { lang: item.code, save: false, reload: true });

            }
        },

        async initializeHash() {
            if (this.isDev) {
                this.$store.commit('setCurrentBuildHash', 'DEV-HASH');
                console.log('App in DEV-Modus gestartet.');
                this.loadingInitialHash = false;
                return;
            }

            console.log('App in PRODUCTION-Modus: Initialen Hash abrufen...');
            const initialHash = await fetchInitialHash();

            if (initialHash) {
                // Den Hash im Vuex Store speichern
                this.$store.commit('setCurrentBuildHash', initialHash);
                console.log(`Initialer Build-Hash gespeichert: ${initialHash}`);
            } else {
                console.error('Konnte initialen Build-Hash nicht laden.');
            }
            this.loadingInitialHash = false;
        }




    },

}
</script>